// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:focus {
  outline: none;
}
input::-webkit-contacts-auto-fill-button {
  visibility: hidden;
}
div[data-carousel='wrapper'] div[style*='touch-action: none'] {
  touch-action: pan-y !important;
}
`, "",{"version":3,"sources":["webpack://./App/Routes/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[":focus {\n  outline: none;\n}\ninput::-webkit-contacts-auto-fill-button {\n  visibility: hidden;\n}\ndiv[data-carousel='wrapper'] div[style*='touch-action: none'] {\n  touch-action: pan-y !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
